import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import LoginPicture from "../../images/DoctorImage.svg";
import { Button, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { changePassword, getLogin, sendResetPasswordEmail } from "../../api/Login";
import Loader from "../../customJS/Loader";
import { changePasswordUrl } from "../../config/app-config";

function ResetPassword() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log("URl", atob(urlParams.get("signin")));
    setUserId(atob(urlParams.get("signin")));
  }, []);

  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = (values) => {
    var obj = {
      mailId: values.mailId,
      url: changePasswordUrl,
    };

    // console.log("LOGINUSER:", loginUser, values);

    setLoader(true);
    sendResetPasswordEmail(obj)
      .then((response) => {
        if (response.data.status === 1) {

          messageApi.open({
            type: 'success',
            content: "We have sent a reset password link to your email.",
            duration: 3,
            className: 'ant-alert',
            onClose: () =>{
                navigate("/login");
                setLoader(false);
              }
          });
        }else{
          messageApi.open({
            type: 'error',
            content: "We could not find the specified Email.",
            duration: 1,
            className: 'ant-alert',
          });
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        messageApi.open({
          type: "error",
          content: "Network error, Please try again later.",
          duration: 1,
          className: "ant-alert",
        });
        setLoader(false);
      });
    // console.log("Success:", loginUser);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Prevent form submission when pressing Enter
      event.preventDefault();
    }
  };

  return (
    <Row className="m-0 d-flex justify-content-center align-items-center">
      {contextHolder}
      {loader && <Loader />}
      <Col lg={6} className="h-100">
        <div className="d-flex flex-column h-100 mx-md-5 px-md-5 justify-content-center">
          <div className="fromData">
            <Form
              form={form}
              name="createPassword"
              onFinish={onFinish}
              autoComplete="off"
              // style={{ maxWidth: 400, margin: "0 auto" }}
              layout="vertical"
            >
              {/* <div className="text-center"> */}
                <h2 className="uniteColor font-family-Mar">Forgot your Password ?</h2>
                <p className="unitedTextColor">
                  <small>
                    Please enter the email address associated with your account,
                    and we'll email you a link to reset your password.
                  </small>
                </p>
              {/* </div> */}

              <Form.Item
                label="Email"
                name="mailId"
                rules={[
                  {
                    required: true,
                    message: "Please Enter your email",
                  }
                ]}
              >
                <Input placeholder="Enter your email" autoComplete="off"
                />
              </Form.Item>

              
              <Button
                type="primary"
                block
                className="uniteButton py-4 mt-2"
                htmlType="submit"
                size="lg"
              >
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </Col>
      <Col lg={6} className="d-flex justify-content-center">
        <img src={LoginPicture} alt="doctor image.png" height="500" width="500" />
      </Col>
    </Row>
  );
}

export default ResetPassword;
